import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    standalone: true,
    imports: [CommonModule],
    template: `<img src="/assets/TL_icon_loader.svg" alt="global-loader" />`,
    styles: `
        img {
            width: 250px;
            height: 250px;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalLoaderComponent {}
